import {httpAction, getAction, postAction} from '@/api/manage'
//同意
export function agree(that){
  /*if(applicationCode === 'env_audit'){
    epm_agree(that);
  }else if(applicationCode === 'ipsys'){
    ipsys_agree(that)
  }*/
  that.confirmLoading = true;
  postAction("/sys/bpm-signed/process/"+that.model.businessFormNo,{"action":"Y","businessFormNo":that.model.businessFormNo,"reviewerId":that.$store.getters.userInfo.workNo,"remarks":that.model.comments}).then(res=>{
    that.confirmLoading = false;
    if (res.success) {
      that.$emit('close');
      // if(that.$refs.applicationModel.hasOwnProperty('checkApprovedCallback')){
      //   that.$refs.applicationModel.checkApprovedCallback()
      // }
    } else {
      that.$message.warning(res.message);
    }
  })
}
function epm_agree(that) {
  let map = {};
  map.pfBpmProcessId = that.model.processGuid;
  map.comments = that.model.comments;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Agree";
  map.taskCode = that.model.taskCode;
  // that.confirmLoading = true;
  postAction("/sys/electronicSigned/envProcess/"+that.model.processGuid, map).then((res) => {
    if (res.success) {
      that.$emit('close');
      that.confirmLoading = false;
    }
  })
}
function ipsys_agree(that) {
  if(that.model.task_code==='ApproveTask8'){
    if(!that.model.file||(that.model.file&&that.model.file.pfBpmFileDetailList.length===0)){
      // that.$message.warning("请在附档中上传附件再送出！");
      that.$message.warning(that.language['eletronicSigned.fileUrlsWarn'])
      return;
    }
  }
  let map = {};
  map.processGuid = that.model.process_guid;
  map.taskCode = that.model.task_code;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.comments = that.model.comments;
  map.approveAction = "Agree";
  map.file = that.model.file;
  that.confirmLoading = true;
  postAction("/sys/electronicSigned/ipsysProcess/"+that.model.process_guid, map).then((res) => {
    if (res.success) {
      that.$emit('close');
      that.confirmLoading = false;
    }
  })

}